import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { useSettings } from '../../hooks/useContent';
import { useLanguage } from '../../context/LanguageContext';
import type { SiteLink } from '../../types';

const fallback: SiteLink[] = [
  { label: 'About', url: '/about' }, { label: 'Movement', url: '/movement' },
  { label: 'Speakers', url: '/speakers' }, { label: 'Martyrs', url: '/tribute' },
  { label: 'Program', url: '/agenda' }, { label: 'Stories', url: '/stories' },
  { label: 'Updates', url: '/news' }
];
const requiredLinks: SiteLink[] = [{ label: 'Speakers', url: '/speakers' }, { label: 'Martyrs', url: '/tribute' }];

function withRequiredLinks(links: SiteLink[]) {
  const result = links.filter(link => link.label.trim() && link.url.trim());
  for (const required of requiredLinks) if (!result.some(link => link.url === required.url)) result.push(required);
  return result;
}

export function Header() {
  const [open, setOpen] = useState(false), [scrolled, setScrolled] = useState(false);
  const { data: settings } = useSettings(), { language, setLanguage, t } = useLanguage();
  const links = withRequiredLinks(settings?.navigationLinks?.length ? settings.navigationLinks : fallback);
  useEffect(() => { const fn = () => setScrolled(scrollY > 28); addEventListener('scroll', fn, { passive: true }); return () => removeEventListener('scroll', fn); }, []);
  const close = () => setOpen(false);
  return <header className={`header ${scrolled ? 'scrolled' : ''}`}>
    <Link to="/" className="brand brand-logo" aria-label={`${settings?.siteName || 'GenZ Conclave'} home`} onClick={close}><img src="/images/logo%201.png?v=classic" alt={settings?.siteName || 'GenZ Conclave'}/></Link>
    <nav className={open ? 'open' : ''} aria-label={t('Main navigation')}>
      {links.map(({ label, url }) => url.startsWith('http') ? <a key={`${label}-${url}`} href={url} target="_blank" rel="noreferrer" onClick={close}>{t(label)}</a> : <NavLink key={`${label}-${url}`} to={url} onClick={close}>{t(label)}</NavLink>)}
      <Link className="nav-cta" to="/contact" onClick={close}>{t(settings?.headerCtaLabel || 'Join the dialogue')} <ArrowUpRight size={16}/></Link>
    </nav>
    <div className="header-tools"><div className="language-switch" role="group" aria-label="Language"><button className={language === 'en' ? 'active' : ''} onClick={() => setLanguage('en')} lang="en">EN</button><span>/</span><button className={language === 'ne' ? 'active' : ''} onClick={() => setLanguage('ne')} lang="ne">ने</button></div><button className="menu" onClick={() => setOpen(!open)} aria-expanded={open} aria-label={t(open ? 'Close menu' : 'Open menu')}>{open ? <X/> : <Menu/>}</button></div>
  </header>;
}
